import { useState, useEffect, useRef } from "react";
import Varanouslabslogo from "../../assets/Varanouslabslogo.png";
import Profile from "../../assets/profile.jpg";
import EnvDetails from  '../env_config'

import LoginService from "../../Services/login_service";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { motion } from "framer-motion";
import { FiSettings, FiRefreshCcw } from "react-icons/fi";
import { FiInfo } from "react-icons/fi";
const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    { name: "Home", icon: "🏠", route: "/customerPortal/MyDashboard" },
    { name: "RFQs", icon: "📋", route: "/customerPortal/Rfqs" },
    { name: "Quotations", icon: "📝", route: "/customerPortal/quotations" },
    { name: "Orders", icon: "🛒", route: "/customerPortal/orders" },
    { name: "Products", icon: "📦", route: "/Products", externalPage: true },
    { name: "Terms of Use", icon: "📜", route: "/terms-conditions" },
    { name: "Help", icon: "❓", route: "/help" },
  ];

  const handleClick = (item) => {
    navigate(item.route);
  };

  return (
    <div className="w-64 h-screen bg-white-100 p-4 fixed">
      <div className="mb-8 cursor-pointer" onClick={() => navigate("/")}>
        <img src={Varanouslabslogo} alt="Varanous Logo" style={{ height: 100 }} />
      </div>

      <nav>
        {menuItems.map((item, index) => {
          const isActive =
            location.pathname.toLowerCase() === item.route.toLowerCase();

          return (
            <div
              key={index}
              onClick={() => handleClick(item)}
              className={`flex items-center p-2 mb-2 rounded cursor-pointer ${
                isActive ? "text-white" : "text-gray-700 hover:bg-gray-200"
              }`}
              style={isActive ? { backgroundColor: "#2b6e73" } : {}}
            >
              <span className="mr-3">{item.icon}</span>
              <span>{item.name}</span>
            </div>
          );
        })}
      </nav>
    </div>
  );
};

const Header = () => {
  const [user, setUser] = useState({});
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();
  const isLaptopMode = window.innerWidth >= 1024;

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const currentUser = await LoginService.getCurrentUser();
        setUser(currentUser || {});
      } catch (error) {
        console.error("Failed to fetch user:", error);
        setUser({});
      }
    };
    fetchUser();
  }, []);

  const handleLogout = () => {
    try {
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      setUser({}); // Clear user details
      setShowProfile(false); // Close profile dropdown
      navigate("/"); // Navigate to root page
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="flex items-center justify-between p-4 bg-white shadow ml-64 relative">
      <div></div> {/* Placeholder to maintain layout balance */}
      <section className="user-profile-section" ref={profileRef}>
        <button
          className="profile-toggle-button flex items-center"
          onClick={() => setShowProfile((prev) => !prev)}
        >
          <img
            src={Profile}
            alt="User Avatar"
            className="w-10 h-10 rounded-full mr-2"
          />
          <span className="font-medium text-red-700">
            {user.firstName || "User"}
          </span>
        </button>

        {showProfile && (
          <div className="user-profile-details space-y-2 p-4 absolute right-4 top-14 bg-white shadow-lg rounded border z-10">
            {[
              { label: "First Name", value: user.firstName },
              { label: "Last Name", value: user.lastName },
              { label: "Email", value: user.email },
              { label: "Mobile", value: user.mobile },
              { label: "Company", value: user.company },
            ].map(
              (item, index) =>
                item.value && (
                  <div key={index} className="flex">
                    <span className="w-[100px] font-semibold">
                      {item.label}
                    </span>
                    <span className="w-4 text-right">:</span>
                    <span className="flex-1 pl-2">{item.value}</span>
                  </div>
                )
            )}
            <div className="flex justify-around">
              <button
                onClick={() => setShowProfile(false)}
                className="mt-4 px-4 py-0 bg-black text-white rounded hover:bg-black"
              >
                Close
              </button>
              <button
                onClick={handleLogout}
                className="mt-4 px-4 py-0 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Logout
              </button>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

const MyDashboard = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 ml-64">
        <Header />
        <div className="p-4 bg-gray-100">
          <Outlet />
        </div>

        {/* Version Code */}
       {/* Version Code */}
<div className="fixed left-32 bottom-4 z-50 flex items-center gap-3 bg-gray-100/20 backdrop-blur-md rounded-xl shadow-lg">
  {/* Gear Icon with rotation + subtle scale */}
  <motion.div
    animate={{ rotate: [0, 360], scale: [1, 1.1, 1] }}
    transition={{ repeat: Infinity, duration: 5, ease: "linear" }}
    className="text-green-500"
  >
    <FiSettings size={18} />
  </motion.div>

  {/* Version Text with pulsing color */}
  <motion.p
    className="text-gray-600 text-sm font-medium"
    animate={{ color: ["#4ade80", "#22c55e", "#4ade80"] }}
    transition={{ repeat: Infinity, duration: 2 }}
  >
    Ver: <span className="font-bold">{EnvDetails.getVersionInfo()}</span>
  </motion.p>
</div>

      </div>
    </div>
  );
};

export default MyDashboard;
